// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCHVXUKJS2Czb2s0pKwj5qwKIrMJKYXGbg",
  authDomain: "mama-john.firebaseapp.com",
  projectId: "mama-john",
  storageBucket: "mama-john.appspot.com",
  messagingSenderId: "904973976583",
  appId: "1:904973976583:web:59d632c7d643efe1e556a2",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
